var _a, _b, _c, _d, _e, _f;
export const OCR_API_ENDPOINTS = {
    OCR_API: (_a = process.env.OCR_API) !== null && _a !== void 0 ? _a : "",
    BUSHWHACK_API: (_b = process.env.BUSHWHACK_API) !== null && _b !== void 0 ? _b : "",
    SECRET_SHOP_API: (_c = process.env.SECRET_SHOP_API) !== null && _c !== void 0 ? _c : "",
    GATEWAY_API_HOST: (_d = process.env.GATEWAY_API_HOST) !== null && _d !== void 0 ? _d : "",
    BASE_API_V3: (_e = process.env.BASE_API_V3) !== null && _e !== void 0 ? _e : "",
    GREEVILS_GREED_API: (_f = process.env.GREEVILS_GREED_API) !== null && _f !== void 0 ? _f : "",
};
//# sourceMappingURL=OcrApiEndpoints.js.map